import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Input, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SelectTerritorialUnitsCode from "../../../../components/selects/SelectTerritorialUnitsCode";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterProcessingCapacity = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [selectedRegionId, setSelectedRegionId] = useState<number|null>(null);
  const [selectedRegionCode, setSelectedRegionCode] = useState<string|null>(null);
  const [selectedAreaCode, setSelectedAreaCode] = useState<string|null>(null);
  const [selectedAreaId, setSelectedAreaId] = useState<number|null>(null);
  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ [8, 8] }>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Наименование организации') }
			name={ props.formField.orgName }
		  >
			<Input type='text'/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('ПИН') }
			name={ props.formField.pin }
		  >
			<Input type='text'/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Область') }
			name={ props.formField.regionId }
		  >
			<SelectTerritorialUnitsCode
			  parentId={ 1 }
			  onChange={ (value, option: any) => {
				setSelectedRegionId(Number(value));
				setSelectedRegionCode(option?.data?.code);
				setSelectedAreaCode(null);
				setSelectedAreaId(null);
				form.setFieldsValue({
				  [props.formField.regionId]: value,
				  [props.formField.areaId]: null, // Сбрасываем район
				  [props.formField.territorialUnitId]: null, // Сбрасываем населенный пункт
				});
			  } }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Район') }
			name={ props.formField.areaId }
		  >
			<SelectTerritorialUnitsCode
			  type={ ['AREA'] }
			  parentId={ selectedRegionId }
			  onChange={ (value, option: any) => {
				setSelectedAreaCode(option?.data?.code || null);
				setSelectedAreaId(value as number);
				form.setFields([{ name: props.formField.territorialUnitId, value: null }]);
			  } }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('Населенный пункт') }
			name={ props.formField.territorialUnitId }
		  >
			<SelectTerritorialUnitsCode areaCode={ selectedAreaCode }/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 24 } md={ 24 } lg={ 24 }>
		  <div style={ { marginTop: 4 } }>
			<Button
			  type="primary"
			  shape="default"
			  icon={ <SearchOutlined/> }
			  style={ { marginRight: 8 } }
			  onClick={ props.onSearch }
			>
			  { t('general.search') }
			</Button>
			<Button
			  type="link"
			  onClick={ props.onReset }
			  style={ { color: "orange" } }
			>
			  { t('general.reset') }
			</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  );
};
